import {AvatarStack} from '@primer/react'
import {SkeletonText} from '@primer/react/experimental'
import {GitHubAvatar} from '@github-ui/github-avatar'
import type {SidebarUsedByProps} from '../types'
import styles from './SidebarUsedBy.module.css'
import {SidebarSection} from './SidebarSection'
import {SidebarLink} from './SidebarLink'

/** Renders the Used By section of the repository sidebar. */
export function SidebarUsedBy({dependentCount, dependents, dependentsPath}: SidebarUsedByProps) {
  if (dependentCount === 0 || dependents.length === 0) {
    return null
  }

  const countRounded = Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    maximumSignificantDigits: 2,
  }).format(dependentCount)
  return (
    <SidebarSection title="Used by" href={dependentsPath} count={countRounded}>
      <SidebarLink to={dependentsPath} className={styles.avatarRow} analyticsLabel="section:used_by">
        <AvatarStack disableExpand variant="stack">
          {dependents.map(dep => (
            <GitHubAvatar key={dep.ownerLogin} src={dep.avatarUrl} alt={`@${dep.ownerLogin}`} size={32} />
          ))}
        </AvatarStack>

        {dependentCount > dependents.length && (
          <span className={styles.moreCount}>{`+ ${(dependentCount - dependents.length).toLocaleString()}`}</span>
        )}
      </SidebarLink>
    </SidebarSection>
  )
}

export function SidebarUsedBySkeleton() {
  return (
    <SidebarSection title="Used by">
      <SkeletonText />
    </SidebarSection>
  )
}
